import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo, useCallback } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogDetailCurators } from '@/redux/modules/catalog/detail/catalogDetail.selectors';
import { getCuratorBaseUrl } from '@/redux/modules/config';
import { getCuratorImageUrl } from '@/utils/urls';

import { DescriptionSection } from '../ItemDescription/DescriptionSection';

type Curator = {
    expertise: string;
    id: number;
    imageFileName: string;
    name: string;
};

type Props = {
    catalogId: number;
    className?: string;
};

const imageSize = 140;

const CuratorInfoComponent = ({ catalogId, className }: Props) => {
    const catalogCurators = useAppSelector((state) => getCatalogDetailCurators(state, catalogId));
    const curatorBaseUrl = useAppSelector(getCuratorBaseUrl);

    const mapCurators = useCallback(
        (curator: Curator) => {
            return (
                <div
                    className="mt-sm flex"
                    key={curator.id}
                >
                    <div className="relative flex h-[70px] min-h-[70px] w-[70px] min-w-[70px] items-center justify-center overflow-hidden rounded-full">
                        <img
                            alt={curator.name}
                            className="max-h-full max-w-full object-contain"
                            height={70}
                            loading="lazy"
                            src={getCuratorImageUrl(curatorBaseUrl, curator.id, curator.imageFileName, imageSize)}
                            width={70}
                        />
                    </div>
                    <div className="ml-sm flex w-full flex-col items-start justify-center">
                        <LabelStrong>{curator.name}</LabelStrong>
                        <BodySecondary color="secondary">{curator.expertise}</BodySecondary>
                    </div>
                </div>
            );
        },
        [curatorBaseUrl]
    );

    if (!catalogCurators.length) {
        return null;
    }

    return (
        <DescriptionSection
            body={catalogCurators.map(mapCurators)}
            className={cn('py-md', className)}
            header="bidding_console.console.currentLiveItem.curator.curatedBy"
        />
    );
};

export const CuratorInfo = memo<Props>(CuratorInfoComponent);
